import React from "react";

const Action = ({ children }) => <div>{children}</div>;

export default Action;
